// A date on its own means the whole of that day, not the midnight it starts at.
export const END_OF_DAY = '23:59';

// "YYYY-MM-DDTHH:mm" reads as local time in every engine; Safari rejects "2030-01-15 " (a
// cleared time), which used to save a coupon with no expiry.
export const buildRedeemBy = (date, time) => new Date(`${date}T${time || END_OF_DAY}`);
